import styled from 'styled-components';

export const Wrapper = styled.main`
  padding: 20px 30px 50px;
  @media (max-width: 767px) {
    padding-left: 16px;
    padding-right: 16px;
  }
  min-height: calc(100vh - 120px);

  .layout {
    display: flex;
    gap: 24px;
    align-items: flex-start;
  }

  .sidebar {
    width: 260px;
    background: var(--color-surface) !important;
    border: 1px solid var(--color-border);
    border-radius: 12px;
    padding: 12px;
    box-shadow: 0 8px 10px var(--color-shadow);
    color: var(--color-text);
    max-height: calc(100vh - 200px);
    position: sticky;
    top: 20px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .sidebar-header {
    font-family: 'General Sans', sans-serif;
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    color: var(--color-text-muted);
    margin: 0 0 8px;
    text-transform: uppercase;
    letter-spacing: 0.02em;
  }

  .sidebar-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow: auto;
    padding-right: 4px;
  }

  .prompt-item {
    width: 100%;
    text-align: left;
    background: var(--color-surface-muted);
    border: 1px solid transparent;
    border-radius: 10px;
    padding: 10px 12px;
    color: var(--color-accent);
    font-weight: 600;
    font-size: 13px;
    line-height: 18px;
    transition: all 0.15s ease-in-out;

    &:hover {
      background: color-mix(in srgb, var(--color-surface-muted) 70%, var(--color-accent) 30%);
      border-color: var(--color-border);
    }

    &.active {
      background: color-mix(in srgb, var(--color-surface-muted) 55%, var(--color-accent) 45%);
      border-color: var(--color-accent);
      color: var(--color-text);
    }
  }

  .empty-state {
    font-size: 12px;
    color: var(--color-text-muted);
    padding: 4px 2px;
  }

  .main-panel {
    flex: 1;
    background: var(--color-surface) !important;
    border: 1px solid var(--color-border);
    border-radius: 12px;
    padding: 16px 20px 24px;
    box-shadow: 0 8px 10px var(--color-shadow);
    color: var(--color-text);
  }

  .version {
    text-align: left;
    display: inline-flex;
    width: 100%;
    position: relative;

    font-family: 'General Sans', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    color: var(--color-text-muted);
  }

  .variables {
    font-family: 'General Sans', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    color: var(--color-text-muted);
  }

  .variables.rounded-xl {
    background: var(--color-surface-muted) !important;
    border-color: var(--color-border) !important;
    color: var(--color-text);
  }

  @media (max-width: 767px) {
    .flex-block {
      flex-direction: column;
    }
  }

  .first-stage {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .flex-block {
      display: flex;
      gap: 20px;
      justify-content: space-between;
      align-items: flex-start;
      padding: 0 0 20px;
      width: 100%;

      .head-line {
        display: flex;
        gap: 10px;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        .title {
          font-size: 12px;
          font-weight: 600;
          line-height: 18px;
          text-align: left;
          color: var(--color-text-muted);
        }

        svg {
          cursor: pointer;

          :hover {
            color: var(--color-accent);
          }
        }
      }

      .left-wrapper,
      .right-wrapper {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        justify-content: space-between;
        align-items: flex-start;
        width: 100%;

        textarea {
          min-height: 40vh;
        }
      }
    }
  }

  .second-stage {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .flex-block {
      display: flex;
      gap: 20px;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px 10px;
      width: 100%;

      .left-wrapper,
      .right-wrapper {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        justify-content: flex-end;
        align-items: center;
        width: 100%;

        .lines {
          font-size: 12px;
          font-weight: 600;
          line-height: 18px;
          text-align: left;
          color: var(--color-text-muted);
        }
      }
    }
    button {
      width: 125px;
    }

    .diff {
      min-width: 0;
      overflow-x: auto;
      width: 100%;
      background: var(--color-surface);
      box-shadow: 0 8px 10px var(--color-shadow);
      border-radius: 10px;
      position: relative;
      flex: 1 0 auto;
      margin: 0 0 20px;

      table {
        background: transparent;
        * {
          font-family: 'General Sans', sans-serif !important;
          font-size: 16px !important;
          line-height: 24px !important;
        }
      }
      table tbody tr:first-child td:first-child {
        border-radius: 10px 0 0 0;
      }
      table tbody tr:first-child td:last-child {
        border-radius: 0 10px 0 0;
      }
      table tbody tr:last-child td:first-child {
        border-radius: 0 0 0 10px;
      }
      table tbody tr:last-child td:last-child {
        border-radius: 0 0 10px 0;
      }
    }
  }
`;
